import cn from 'classnames';
import { FC, PropsWithChildren } from 'react';

const BlackBox: FC<PropsWithChildren<{ className?: string; padding?: 'sm' | 'md' | 'lg' }>> = ({
  children,
  className = '',
  padding = 'lg'
}) => (
  <div
    className={cn(
      'p-[1px]',
      { rounded: padding === 'sm', 'rounded-md': padding === 'md', 'rounded-lg': padding === 'lg' },
      className
    )}
    style={{
      backgroundImage: 'linear-gradient(180deg, #808080 -15.63%, rgba(128, 128, 128, 0) 123.96%)'
    }}
  >
    <div
      className={cn('bg-black/80 h-full', {
        'p-2 rounded': padding === 'sm',
        'py-2 px-3 lg:px-4 lg:py-5 rounded-md': padding === 'md',
        'py-3 px-4 lg:px-6 lg:py-6 rounded-lg': padding === 'lg'
      })}
    >
      {children}
    </div>
  </div>
);

export default BlackBox;
